
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Bot, Sparkles } from "lucide-react";
import { AIConcierge } from "./AIConcierge";
import { motion } from "framer-motion";

export const AIConciergeButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <motion.div
        className="fixed bottom-6 right-6 z-40"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1, type: "spring", stiffness: 200 }}
      >
        <Button
          onClick={() => setIsOpen(!isOpen)}
          className={`w-14 h-14 rounded-full shadow-2xl transition-all duration-300 ${
            isOpen 
              ? 'bg-gradient-to-r from-neon-pink to-neon-purple scale-110' 
              : 'bg-gradient-to-r from-neon-purple to-neon-pink hover:scale-110'
          }`}
          style={{
            boxShadow: isOpen 
              ? '0 0 30px rgba(255, 12, 182, 0.6), 0 0 60px rgba(109, 40, 217, 0.4)'
              : '0 0 20px rgba(109, 40, 217, 0.4), 0 0 40px rgba(255, 12, 182, 0.2)'
          }}
        >
          <motion.div
            animate={{ rotate: isOpen ? 180 : 0 }}
            transition={{ duration: 0.3 }}
          >
            <Bot className="w-6 h-6 text-white" />
          </motion.div>
          
          {/* Pulsing effect */}
          <motion.div
            className="absolute inset-0 rounded-full bg-gradient-to-r from-neon-purple to-neon-pink"
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.5, 0.2, 0.5],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />
          
          {/* Sparkle effects */}
          <motion.div
            className="absolute -top-1 -right-1"
            animate={{
              scale: [0, 1, 0],
              rotate: [0, 180, 360],
            }}
            transition={{
              duration: 3,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          >
            <Sparkles className="w-4 h-4 text-neon-cyan" />
          </motion.div>
        </Button>
      </motion.div>

      <AIConcierge isOpen={isOpen} onToggle={() => setIsOpen(!isOpen)} />
    </>
  );
};
